//      
var setFieldTouched = function setFieldTouched(args, state) {
  var name = args[0],
      touched = args[1];
  var field = state.fields[name];

  if (field) {
    field.touched = !!touched;
  }
}; //


export default setFieldTouched;